import type { FC } from 'react';
import clsx from 'clsx';

import LogoEmblem from 'public/images/emblem.svg';
import styles from './LegacyFlowScreen.module.scss';
import type { LegacyClaimStatus, LegacyFlowProps } from 'pages';
import { formatDateWithTimezone } from 'shared/utils';

const titleByStatus: Record<LegacyClaimStatus, string> = {
    success: 'Go ahead and redeem your deal!',
    deal_already_claimed:
        'Your deal is reserved. Visit the store to redeem it.',
    deal_already_redeemed: 'This deal has been redeemed.',
};

const LegacyFlowScreen: FC<LegacyFlowProps> = ({
    dealData,
    status = 'success',
}) => {
    const merchantName = dealData?.merchant_name?.trim();
    const dealName = dealData?.deal_name?.trim();
    const formattedExpirationDate = dealData
        ? formatDateWithTimezone(dealData.end_datetime, dealData.timezone)
        : null;
    const hasDealDetails = Boolean(
        merchantName || dealName || formattedExpirationDate
    );

    return (
        <div className={styles.Wrapper}>
            <LogoEmblem className={styles.LogoEmblem} aria-hidden="true" />
            <h1 className={styles.Title}>
                <div className={styles.TitleContent}>
                    {titleByStatus[status]}
                </div>
            </h1>
            <p className={styles.Description}>
                Simply provide your email address, scan the SpotOn mobile app or
                scan your loyalty card at the counter.
            </p>
            {hasDealDetails && (
                <>
                    {merchantName && (
                        <p className={styles.Description}>
                            Your deal at {merchantName}:
                        </p>
                    )}
                    {dealName && (
                        <p
                            className={clsx(
                                styles.TitleContent,
                                styles.PromoName
                            )}
                        >
                            {dealName}
                        </p>
                    )}
                    {formattedExpirationDate && (
                        <p className={styles.Description}>
                            Expires: {formattedExpirationDate}
                        </p>
                    )}
                </>
            )}
        </div>
    );
};

export default LegacyFlowScreen;
